//= Functions & Modules
// Others
import React, { useContext } from 'react';
import classNames from 'classnames';

//= Structures & Data
// Own
import { TabsMenuItemProps } from '../data/TabsMenuItemProps';
import { ThemeContext } from '../../theme';

export function TabsMenuItem(props: TabsMenuItemProps) {
    const { tabsMenuItemTheme } = useContext(ThemeContext);
    const classes = classNames(
        tabsMenuItemTheme,
        props.active
            ? 'bg-white/[0.08] text-title font-medium'
            : 'text-unselected1 hover:text-unselected2 hover:bg-white/[0.04]',
        props.className
    );

    return (
        <div
            role="button"
            className={classes}
            onClick={() => {
                props.onClick();
            }}
        >
            {props.children}
        </div>
    );
}
